import { Button, PaginationType, Table } from '@octano/global-ui';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../../locales/translations';
import { ITEMS_PER_PAGE_DEFAULT } from '../../../ClosingPeriod/ClosingPeriod';
import { useColumns } from '../hooks/useColumns';
import { useAcademicOffers } from '../loaders/AcademicOffersLoader';
import { NonStructuredAcademicOffer } from '../types';
import { Col } from 'reactstrap';

export function AcademicOffersTable() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );
  const { data, loading, query, updateQuery } = useAcademicOffers();

  const refresh = useCallback(() => {
    updateQuery({ ...query });
  }, [query, updateQuery]);

  const { columns, pendingChanges, isSaving, handleSaveChanges } = useColumns({
    onDelete: refresh,
    onSave: refresh,
  });

  const results = useMemo(() => data?.data ?? [], [data]);

  const paginationTable = useMemo<PaginationType | undefined>(() => {
    if (data) {
      return {
        totalItems: data.total,
        onChangePage: (page) => updateQuery({ ...query, page }),
        itemsPerPage: ITEMS_PER_PAGE_DEFAULT,
        totalPages: data.total_pages,
        currentPage: query.page ?? 1,
      };
    } else {
      return undefined;
    }
  }, [data, query, updateQuery]);

  return (
    <>
      <Table<NonStructuredAcademicOffer>
        columns={columns}
        data={results}
        isLoadingResults={loading}
        noResultsText={t('table.noResults')}
        pagination={paginationTable}
      />
      {pendingChanges.length > 0 && (
        <Col className="d-flex justify-content-end mb-3 pr-0 mt-2">
          <Button
            text={t('table.saveChanges') + ' (' + pendingChanges.length + ')'}
            onClick={handleSaveChanges}
            loading={isSaving}
            disabled={isSaving}
          />
        </Col>
      )}
    </>
  );
}
